"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Events = exports.ClusterReachability = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _common = require("@webex/common");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _util = require("./util");
var _eventsScope = _interopRequireDefault(require("../common/events/events-scope"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// data for the Events.resultReady event

// data for the Events.clientMediaIpsUpdated event

var Events = exports.Events = {
  resultReady: 'resultReady',
  // emitted when a cluster is reached successfully using specific protocol
  clientMediaIpsUpdated: 'clientMediaIpsUpdated' // emitted when more public IPs are found after resultReady was already sent for a given protocol
};
/**
 * A class that handles reachability checks for a single cluster.
 * It emits events from Events enum
 */
var ClusterReachability = exports.ClusterReachability = /*#__PURE__*/function (_EventsScope) {
  (0, _inherits2.default)(ClusterReachability, _EventsScope);
  var _super = _createSuper(ClusterReachability);
  /**
   * Constructor for ClusterReachability
   * @param {string} name cluster name
   * @param {ClusterNode} clusterInfo information about the media cluster
   */
  function ClusterReachability(name, clusterInfo) {
    var _this;
    (0, _classCallCheck2.default)(this, ClusterReachability);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "numUdpUrls", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "numTcpUrls", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "numXTlsUrls", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "result", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pc", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defer", void 0);
    // this defer is resolved once reachability checks for this cluster are completed
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startTimestamp", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isVideoMesh", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "name", void 0);
    _this.name = name;
    _this.isVideoMesh = clusterInfo.isVideoMesh;
    _this.numUdpUrls = clusterInfo.udp.length;
    _this.numTcpUrls = clusterInfo.tcp.length;
    _this.numXTlsUrls = clusterInfo.xtls.length;
    _this.pc = _this.createPeerConnection(clusterInfo);
    _this.defer = new _common.Defer();
    _this.result = {
      udp: {
        result: 'untested'
      },
      tcp: {
        result: 'untested'
      },
      xtls: {
        result: 'untested'
      }
    };
    return _this;
  }

  /**
   * Gets total elapsed time, can be called only after start() is called
   * @returns {Number} Milliseconds
   */
  (0, _createClass2.default)(ClusterReachability, [{
    key: "getElapsedTime",
    value: function getElapsedTime() {
      return Math.round(performance.now() - this.startTimestamp);
    }

    /**
     * Generate peerConnection config settings
     * @param {ClusterNode} cluster
     * @returns {RTCConfiguration} peerConnectionConfig
     */
  }, {
    key: "buildPeerConnectionConfig",
    value: function buildPeerConnectionConfig(cluster) {
      var udpIceServers = cluster.udp.map(function (url) {
        return {
          username: '',
          credential: '',
          urls: [url]
        };
      });

      // STUN servers are contacted only using UDP, so in order to test TCP reachability
      // we pretend that Linus is a TURN server, because we can explicitly say "transport=tcp" in TURN urls.
      // We then check for relay candidates to know if TURN-TCP worked (see registerIceCandidateListener()).
      var tcpIceServers = cluster.tcp.map(function (urlString) {
        return {
          username: 'webexturnreachuser',
          credential: 'webexturnreachpwd',
          urls: [(0, _util.convertStunUrlToTurn)(urlString, 'tcp')]
        };
      });
      var turnTlsIceServers = cluster.xtls.map(function (urlString) {
        return {
          username: 'webexturnreachuser',
          credential: 'webexturnreachpwd',
          urls: [(0, _util.convertStunUrlToTurnTls)(urlString)]
        };
      });
      return {
        iceServers: [].concat((0, _toConsumableArray2.default)(udpIceServers), (0, _toConsumableArray2.default)(tcpIceServers), (0, _toConsumableArray2.default)(turnTlsIceServers)),
        iceCandidatePoolSize: 0,
        iceTransportPolicy: 'all'
      };
    }

    /**
     * Creates an RTCPeerConnection
     * @param {ClusterNode} clusterInfo information about the media cluster
     * @returns {RTCPeerConnection} peerConnection
     */
  }, {
    key: "createPeerConnection",
    value: function createPeerConnection(clusterInfo) {
      try {
        var config = this.buildPeerConnectionConfig(clusterInfo);
        var peerConnection = new RTCPeerConnection(config);
        return peerConnection;
      } catch (peerConnectionError) {
        _loggerProxy.default.logger.warn("Reachability:index#createPeerConnection --> Error creating peerConnection:", peerConnectionError);
        return undefined;
      }
    }

    /**
     * @returns {ClusterReachabilityResult} reachability result for this cluster
     */
  }, {
    key: "getResult",
    value: function getResult() {
      return this.result;
    }

    /**
     * Closes the peerConnection
     *
     * @returns {void}
     */
  }, {
    key: "closePeerConnection",
    value: function closePeerConnection() {
      if (this.pc) {
        this.pc.onicecandidate = null;
        this.pc.onicegatheringstatechange = null;
        this.pc.close();
      }
    }

    /**
     * Resolves the defer, indicating that reachability checks for this cluster are completed
     *
     * @returns {void}
     */
  }, {
    key: "finishReachabilityCheck",
    value: function finishReachabilityCheck() {
      this.defer.resolve();
    }

    /**
     * Aborts the cluster reachability checks by closing the peer connection
     *
     * @returns {void}
     */
  }, {
    key: "abort",
    value: function abort() {
      var CLOSED = _constants.CONNECTION_STATE.CLOSED;
      if (this.pc.connectionState !== CLOSED) {
        this.closePeerConnection();
        this.finishReachabilityCheck();
      }
    }

    /**
     * Adds public IP (client media IPs)
     * @param {string} protocol
     * @param {string} publicIP
     * @returns {void}
     */
  }, {
    key: "addPublicIP",
    value: function addPublicIP(protocol, publicIP) {
      var result = this.result[protocol];
      if (publicIP) {
        var ipAdded = false;
        if (result.clientMediaIPs) {
          if (!result.clientMediaIPs.includes(publicIP)) {
            result.clientMediaIPs.push(publicIP);
            ipAdded = true;
          }
        } else {
          result.clientMediaIPs = [publicIP];
          ipAdded = true;
        }
        if (ipAdded) this.emit({
          file: 'clusterReachability',
          function: 'addPublicIP'
        }, Events.clientMediaIpsUpdated, {
          protocol: protocol,
          clientMediaIPs: result.clientMediaIPs
        });
      }
    }

    /**
     * Registers a listener for the iceGatheringStateChange event
     *
     * @returns {void}
     */
  }, {
    key: "registerIceGatheringStateChangeListener",
    value: function registerIceGatheringStateChangeListener() {
      var _this2 = this;
      this.pc.onicegatheringstatechange = function () {
        var COMPLETE = _constants.ICE_GATHERING_STATE.COMPLETE;
        if (_this2.pc.iceConnectionState === COMPLETE) {
          _this2.closePeerConnection();
          _this2.finishReachabilityCheck();
        }
      };
    }

    /**
     * Checks if we have the results for all the protocols (UDP and TCP)
     *
     * @returns {boolean} true if we have all results, false otherwise
     */
  }, {
    key: "haveWeGotAllResults",
    value: function haveWeGotAllResults() {
      var _this3 = this;
      return ['udp', 'tcp', 'xtls'].every(function (protocol) {
        return _this3.result[protocol].result === 'reachable' || _this3.result[protocol].result === 'untested';
      });
    }

    /**
     * Saves the latency in the result for the given protocol and marks it as reachable,
     * emits the "resultReady" event if this is the first result for that protocol,
     * emits the "clientMediaIpsUpdated" event if we already had a result and only found
     * a new client IP
     *
     * @param {string} protocol
     * @param {number} latency
     * @param {string|null} [publicIp]
     * @returns {void}
     */
  }, {
    key: "saveResult",
    value: function saveResult(protocol, latency, publicIp) {
      var result = this.result[protocol];
      if (result.latencyInMilliseconds === undefined) {
        _loggerProxy.default.logger.log( // @ts-ignore
        "Reachability:index#saveResult --> Successfully reached ".concat(this.name, " over ").concat(protocol, ": ").concat(latency, "ms"));
        result.latencyInMilliseconds = latency;
        result.result = 'reachable';
        if (publicIp) {
          result.clientMediaIPs = [publicIp];
        }
        this.emit({
          file: 'clusterReachability',
          function: 'saveResult'
        }, Events.resultReady, _objectSpread({
          protocol: protocol
        }, result));
      } else {
        this.addPublicIP(protocol, publicIp);
      }
    }

    /**
     * Registers a listener for the icecandidate event
     *
     * @returns {void}
     */
  }, {
    key: "registerIceCandidateListener",
    value: function registerIceCandidateListener() {
      var _this4 = this;
      this.pc.onicecandidate = function (e) {
        var TURN_TLS_PORT = 443;
        var CANDIDATE_TYPES = {
          SERVER_REFLEXIVE: 'srflx',
          RELAY: 'relay'
        };
        var latencyInMilliseconds = _this4.getElapsedTime();
        if (e.candidate) {
          if (e.candidate.type === CANDIDATE_TYPES.SERVER_REFLEXIVE) {
            _this4.saveResult('udp', latencyInMilliseconds, e.candidate.address);
          }
          if (e.candidate.type === CANDIDATE_TYPES.RELAY) {
            var protocol = e.candidate.port === TURN_TLS_PORT ? 'xtls' : 'tcp';
            _this4.saveResult(protocol, latencyInMilliseconds);
            // we don't add public IP for TCP, because in the case of relay candidates
            // e.candidate.address is the TURN server address, not the client's public IP
          }

          if (_this4.haveWeGotAllResults()) {
            _this4.closePeerConnection();
            _this4.finishReachabilityCheck();
          }
        }
      };
    }

    /**
     * Starts the process of doing UDP and TCP reachability checks on the media cluster.
     * XTLS reachability checking is not supported.
     *
     * @returns {Promise}
     */
  }, {
    key: "start",
    value: (function () {
      var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var offer, gatherIceCandidatePromise;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.pc) {
                _context.next = 3;
                break;
              }
              _loggerProxy.default.logger.warn("Reachability:ClusterReachability#start --> Error: peerConnection is undefined");
              return _context.abrupt("return", this.result);
            case 3:
              // Initialize this.result as saying that nothing is reachable.
              // It will get updated as we go along and successfully gather ICE candidates.
              this.result.udp = {
                result: this.numUdpUrls > 0 ? 'unreachable' : 'untested'
              };
              this.result.tcp = {
                result: this.numTcpUrls > 0 ? 'unreachable' : 'untested'
              };
              this.result.xtls = {
                result: this.numXTlsUrls > 0 ? 'unreachable' : 'untested'
              };
              _context.prev = 6;
              _context.next = 9;
              return this.pc.createOffer({
                offerToReceiveAudio: true
              });
            case 9:
              offer = _context.sent;
              this.startTimestamp = performance.now();

              // Set up the state change listeners before triggering the ICE gathering
              gatherIceCandidatePromise = this.gatherIceCandidates(); // not awaiting the next call on purpose, because we're not sending the offer anywhere and there won't be any answer
              // we just need to make this call to trigger the ICE gathering process
              this.pc.setLocalDescription(offer);
              _context.next = 15;
              return gatherIceCandidatePromise;
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](6);
              _loggerProxy.default.logger.warn("Reachability:ClusterReachability#start --> Error: ", _context.t0);
            case 20:
              return _context.abrupt("return", this.result);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 17]]);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
    /**
     * Starts the process of gathering ICE candidates
     *
     * @returns {Promise} promise that's resolved once reachability checks for this cluster are completed or timeout is reached
     */
    )
  }, {
    key: "gatherIceCandidates",
    value: function gatherIceCandidates() {
      this.registerIceGatheringStateChangeListener();
      this.registerIceCandidateListener();
      return this.defer.promise;
    }
  }]);
  return ClusterReachability;
}(_eventsScope.default);
//# sourceMappingURL=clusterReachability.js.map
